import React, { createContext, useContext } from 'react';
import {
  Dispatch,
  State,
  useEditOrderGuideReducer,
} from '@/hooks/use-edit-order-guide-reducer';

export const EditOrderGuideStateContext = createContext<State | null>(null);
export const EditOrderGuideActionsContext = createContext<Dispatch | null>(
  null,
);

export const useEditOrderGuideState = () => {
  const context = useContext(EditOrderGuideStateContext);
  if (!context) {
    throw new Error(
      'useEditOrderGuideState requires a EditOrderGuideContextProvider',
    );
  }

  return context;
};

export const useEditOrderGuideActions = () => {
  const context = useContext(EditOrderGuideActionsContext);
  if (!context) {
    throw new Error(
      'useEditOrderGuideActions requires a EditOrderGuideContextProvider',
    );
  }

  return context;
};

interface Props {
  children?: React.ReactNode;
  initialState?: State;
}

export const EditOrderGuideContextProvider: React.FC<Props> = ({
  children,
  initialState,
}) => {
  const [state, dispatch] = useEditOrderGuideReducer(initialState);
  return (
    <EditOrderGuideStateContext.Provider value={state}>
      <EditOrderGuideActionsContext.Provider value={dispatch}>
        {children}
      </EditOrderGuideActionsContext.Provider>
    </EditOrderGuideStateContext.Provider>
  );
};
